import React from 'react';

import i18 from '../../../i18';
import {supplierApi} from '../../../api';

import DownloadFile from '../../common/DownloadFile';

class Download extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
            loading: true,
        };
    }

    componentDidMount() {
        void this.generateFiles();
    }

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    generateFiles = async () => {
        this.setState({
            loading: true,
        });

        try {
            const responseData = await supplierApi.generate(
                this.getCompanyId(),
                {
                    invoices: this.props.invoices,
                    partners: this.props.partners,
                },
            );

            this.setState({
                files: responseData.files || [],
            });
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt a feldolgozás során. (#1002)',
                ),
            );
        } finally {
            this.setState({
                loading: false,
            });
        }
    };

    renderFiles = () => {
        if (this.state.files.length === 0) {
            return (
                <p>
                    Nem készült letölthető fájl.
                </p>
            );
        }

        return this.state.files.map((file) => (
            <DownloadFile
                key={file.name}
                title={file.title}
                name={file.name}
                url={supplierApi.downloadUrl(
                    this.getCompanyId(),
                )}
            />
        ));
    };

    render() {
        return (
            <section id="supplier-assignment">
                <div className="col-12">
                    <br/>
                    <br/>

                    <h4>
                        {i18.COMMON._processedSuccessfully}
                    </h4>

                    <br/>

                    <div className="text-center">
                        {this.state.loading
                            ? (
                                <p>
                                    Fájlok előkészítése...
                                </p>
                            )
                            : this.renderFiles()}
                    </div>
                </div>
            </section>
        );
    }
}

export default Download;


// WEBPACK FOOTER //
// ./src/components/supplier/steps/Download.js